import React from 'react';

import type { Section } from '../../../../../models';
import { NATURAL_GAS } from '../../../../../constants';
import UtilitiesOwnRentalPropertyAnnualCosts from '../../Utilities/UtilitiesEstimatedAnnualCost/UtilitiesOwnRentalPropertyAnnualCosts';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function NaturalGasOwnRentalPropertyAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesOwnRentalPropertyAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={NATURAL_GAS.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Natural gas"
      utilityOwnRentalPropertyYesField={NATURAL_GAS.FIELD_NAME.OWN_PROPERTY_YES}
      utilityOwnRentalPropertyNoField={NATURAL_GAS.FIELD_NAME.OWN_PROPERTY_NO}
      knowAnnualCostsSimilarRentalUnitField={NATURAL_GAS.FIELD_NAME.KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT}
    />
  );
}

export default NaturalGasOwnRentalPropertyAnnualCosts;
